module.exports = __webpack_public_path__ + "img/TC8X.4b0c0ad1.png";